import { Prisma } from '@repo/database/src/types';
import type { AgentDeal, Country, CountrySubdivision } from '@repo/database/src/types';
import { Transform, Type } from 'class-transformer';
import { IsBoolean, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';

import { PaginationOptionsDto } from '../../pagination-options-types';

/**
 * Filter DTO for regions in the admin dashboard
 */
export class AdminRegionsFilterDto {
  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsString()
  countryName?: string;

  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => value === true || value === 'true')
  hasCountries?: boolean;

  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => value === true || value === 'true')
  hasSubdivisions?: boolean;

  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => value === true || value === 'true')
  hasAgentDeals?: boolean;
}

/**
 * Main DTO for getting regions list with filters, pagination, and sorting
 */
export class GetAdminRegionsDto extends PaginationOptionsDto {
  @IsObject()
  @ValidateNested()
  @IsOptional()
  @Type(() => AdminRegionsFilterDto)
  filter?: AdminRegionsFilterDto;

  @IsOptional()
  sorts?: Array<{ field: string; order: Prisma.SortOrder }>;
}

/**
 * Response DTO for regions list with computed fields
 */
export interface AdminRegionInfoDto {
  // Region information
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;

  // Country information (using Prisma models)
  countries: Country[];
  countriesCount: number;

  // Subdivision information (using Prisma models)
  subdivisions: CountrySubdivision[];
  subdivisionsCount: number;

  // Agent deals information (using Prisma models)
  agentDeals: AgentDeal[];
  agentDealsCount: number;

  // Computed fields
  hasCountries: boolean;
  hasSubdivisions: boolean;
  hasAgentDeals: boolean;
}

/**
 * Response DTO for admin regions list
 */
export interface AdminRegionsResponseDto {
  regions: AdminRegionInfoDto[];
  totalCount: number;
}
